<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <AboveTheFold />
    <AboutMe />
    <Clara />
    <PadelPlus />
    <PokerPower />
    <BlockwareSolutions />
    <TheSill />
    <Dxos />
    <XubioSalaries />
    <XubioGeneral />
    <XubioLibraries />
    <XubioMobileApp />
    <DollarNotifier />
    <PausaWeb />
    <PausaApp />
    <AnimaEdu />
    <MyFooter />
  </div>
</template>

<script>
import AboveTheFold from "@/components/AboveTheFold.vue";
import XubioSalaries from "@/components/XubioSalaries.vue";
import AboutMe from "@/components/AboutMe.vue";
import XubioGeneral from "@/components/XubioGeneral.vue";
import PausaApp from "@/components/PausaApp.vue";
import PausaWeb from "@/components/PausaWeb.vue";
import AnimaEdu from "@/components/AnimaEdu.vue";
import MyFooter from "@/components/MyFooter.vue";
import XubioLibraries from "@/components/XubioLibraries.vue";
import XubioMobileApp from "@/components/XubioMobileApp.vue";
import DollarNotifier from "@/components/DollarNotifier.vue";
import Dxos from "@/components/Dxos.vue";
import TheSill from "@/components/TheSill.vue";
import BlockwareSolutions from "@/components/BlockwareSolutions.vue";
import PokerPower from "@/components/PokerPower.vue";
import PadelPlus from "@/components/PadelPlus.vue";
import Clara from "@/components/Clara.vue";

export default {
  name: "Home",
  components: {
    AboveTheFold,
    XubioSalaries,
    AboutMe,
    XubioGeneral,
    PausaApp,
    PausaWeb,
    AnimaEdu,
    MyFooter,
    XubioLibraries,
    XubioMobileApp,
    DollarNotifier,
    Dxos,
    TheSill,
    BlockwareSolutions,
    PokerPower,
    PadelPlus,
    Clara,
  },
};
</script>
